import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.restoreScroll()
  }

  preserve() {
    sessionStorage.setItem(this.storageKey, window.scrollY)
  }

  restoreScroll() {
    const scrollY = sessionStorage.getItem(this.storageKey)

    if (scrollY === null) return

    sessionStorage.removeItem(this.storageKey)

    // Let the browser finish layout after redirect/render
    requestAnimationFrame(() => {
      window.scrollTo(0, parseInt(scrollY, 10))
    })
  }

  get storageKey() {
    return "preserve-scroll-y"
  }
}
